// frontend/src/components/QuickAccessBar.js
// Global quick access navigation bar - shown on all pages (desktop only)

import React from 'react';
import { Typography } from 'antd';
import {
    HomeOutlined,
    TeamOutlined,
    FileTextOutlined,
    ReadOutlined,
    BookOutlined,
    BellOutlined,
    CheckCircleOutlined,
    SettingOutlined,
    CalendarOutlined,
    DollarOutlined,
    UserOutlined,
    BarChartOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useSettings } from '../context/SettingsContext';
import './QuickAccessBar.css';

const { Text } = Typography;

// Icon mapping for dynamic rendering
const ICON_MAP = {
    HomeOutlined: <HomeOutlined />,
    TeamOutlined: <TeamOutlined />,
    FileTextOutlined: <FileTextOutlined />,
    ReadOutlined: <ReadOutlined />,
    BookOutlined: <BookOutlined />,
    BellOutlined: <BellOutlined />,
    CheckCircleOutlined: <CheckCircleOutlined />,
    SettingOutlined: <SettingOutlined />,
    CalendarOutlined: <CalendarOutlined />,
    DollarOutlined: <DollarOutlined />,
    UserOutlined: <UserOutlined />,
    BarChartOutlined: <BarChartOutlined />,
};

const QuickAccessBar = ({ isMobile }) => {
    const location = useLocation();
    const { quickAccessItems } = useTheme();
    const { settings } = useSettings();

    // Check if quick-access module is enabled globally
    const isQuickAccessEnabled = settings?.modules_enabled?.['quick-access'] !== false;

    // Hide on mobile or if module is disabled
    if (isMobile || !isQuickAccessEnabled) return null;

    // Filter only enabled items
    const enabledItems = quickAccessItems.filter(item => item.enabled);

    // Don't render if no items enabled
    if (enabledItems.length === 0) return null;

    const isActive = (key) => {
        if (key === '/') return location.pathname === '/';
        return location.pathname.startsWith(key);
    };

    return (
        <div className="quick-access-bar">
            {enabledItems.map((item) => (
                <Link
                    key={item.key}
                    to={item.key}
                    className={`quick-access-item ${isActive(item.key) ? 'active' : ''}`}
                >
                    <div
                        className="quick-access-icon"
                        style={{ color: isActive(item.key) ? item.color : '#666' }}
                    >
                        {ICON_MAP[item.icon] || <HomeOutlined />}
                    </div>
                    <Text
                        className="quick-access-label"
                        style={{ color: isActive(item.key) ? item.color : '#666' }}
                    >
                        {item.label}
                    </Text>
                </Link>
            ))}
        </div>
    );
};

export default QuickAccessBar;
